import './Footer.css';

function Footer(props) {
    return (
        <div style={{
            ...props.style
        }}>
            <div className="buttonsFooter">
                <a href="https://www.fiverr.com/s/0bZ9WD2">
                    <img src="/Under_Button2_Blue%20(2).png" className="button"/>
                </a>
                <a href="https://t.me/Kirilll2002">
                    <img src="/Under_Button3_Blue%20(2).png" className="button"/>
                </a>
            </div>
        </div>
    );
}

export default Footer;